import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import UnitSelector from 'src/component/UI/UnitSelector';
import FeatureFence from 'src/component/FeatureFence';

interface FilterBarProps {
  includeGrid?: boolean;
}

export default function FilterBar (props: FilterBarProps) {
  const { includeGrid } = props;

  const inner = (
    <Paper>
      <FeatureFence can='eht-process-data'>
        <UnitSelector />
      </FeatureFence>
    </Paper>
  );

  if (includeGrid) {
    return (
      <Grid item xs={12} md={12}>
        {inner}
      </Grid>
    );
  }

  return inner;
}

FilterBar.propTypes = {
  includeGrid: PropTypes.bool
};

FilterBar.defaultProps = {
  includeGrid: false
};
